import { RSAA } from 'redux-api-middleware';
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from '../../config/ApiConstants';


export function edit_user_Action(data, token, userId, organisationId) {
    // var searchbyname = data ? data : "";
    // console.log("data Action--",data);
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/organisation/group/edit-user-details/${userId}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                'Authorization': `Bearer ${token}`,
                organisationId: organisationId,
                },
            body:JSON.stringify(data),
            types: [
                types.EDIT_USER_REQUEST,
                types.EDIT_USER_RECEIVE, {
                    type: types.EDIT_USER_FAILURE,
                    meta: (action, state, res) => {
                        return (action, state, res);
                    }
                }]
        }
    }
}

export const resetedit_user_Action = () => {
    return {
        type: types.RESET_EDIT_USER,
        payload: null
    }
};
